<template>
  <vl-properties-list v-vl-spacer:bottom.small>
    <vl-properties-label>{{ $t('productgroup.detail.id') }}</vl-properties-label>
    <vl-properties-data>{{ props.detail.id }}</vl-properties-data>
    <vl-properties-label>{{ $t('productgroup.detail.label') }}</vl-properties-label>
    <vl-properties-data>{{ props.detail.label }}</vl-properties-data>
    <vl-properties-label>{{ $t('productgroup.detail.description') }}</vl-properties-label>
    <vl-properties-data>{{ props.detail.description ? props.detail.description : `-` }}</vl-properties-data>
    <vl-properties-label>{{ $t('productgroup.detail.emails') }}</vl-properties-label>
    <vl-properties-data>
      <ul v-if="emails.length">
        <li v-for="email in emails" :key="email.id">{{ email.emailAddress }}</li>
      </ul>
      <template v-else>{{ $t('productgroup.detail.noEmails') }}</template>
    </vl-properties-data>
  </vl-properties-list>

  <vl-title v-vl-spacer:top.medium tag-name="h4">{{ $t('productgroup.detail.members') }}</vl-title>
  <vl-data-table-extended
    :data="members"
    :columns="columnMap"
    :meta="{
      totalRows: members.length,
      resultsPerPage: members.length,
      currentPage: 1
    }"
    mod-clickable-rows
    mod-zebra
    mod-hide-pagination
  >
    <template v-slot:noresults>
      <div v-vl-align:left>
        <div class="vl-u-spacer--large">
          <p>{{ $t('productgroup.detail.noMembers') }}</p>
        </div>
      </div>
    </template>
  </vl-data-table-extended>
</template>
<script lang="ts" setup>
import 'vue-i18n';
import { computed } from 'vue';
import { ProductGroupDetailDto } from '@/api/backoffice/clients';
import { useI18n } from 'vue-i18n';
import { ColumnDefExtended } from '@/components/vl-data-table-extended/types';
import { RowData } from '@tanstack/vue-table';

const { t } = useI18n();

const props = defineProps<{
  detail: ProductGroupDetailDto;
}>();

const emails = computed(() => {
  return [...(props.detail.emails ?? [])].sort((x, y) => (x.emailAddress > y.emailAddress ? 1 : -1));
});

const members = computed(() => {
  return (
    props.detail.productProcessDefinitions
      ?.map((member) => {
        return {
          id: member.productProcessDefinitionId,
          label: member.productProcessDefinition?.label ?? '-',
          dataConnectionCode: member.dataConnectionCode ?? '-',
          switchDependency: member.switchDependency ? t('general.yes') : t('general.no'),
          routerLink: `/configuration/productprocessdefinition/${member.productProcessDefinitionId}`
        };
      })
      .sort((x, y) => (x.label > y.label ? 1 : -1)) ?? []
  );
});

const columnMap = computed((): ColumnDefExtended<RowData>[] => {
  return [
    {
      accessorKey: 'id',
      header: t('productgroup.detail.member.id'),
      size: 15,
      link: true
    },
    {
      accessorKey: 'label',
      header: t('productgroup.detail.member.label'),
      size: 60,
      link: true
    },
    {
      accessorKey: 'dataConnectionCode',
      header: t('productgroup.detail.member.dataConnectionCode'),
      size: 60,
      link: true
    },
    {
      accessorKey: 'switchDependency',
      header: t('productgroup.detail.member.switchDependency'),
      size: 25,
      link: true
    }
  ];
});
</script>
